import { defineMessages } from 'react-intl'

export default defineMessages({
  whatHappendHeadline: {
    id: 'app.whatHappened.headline',
    defaultMessage: 'What happened',
  },
  whatHappendAddDamageHeadline: {
    id: 'app.whatHappened.addDamageHeadline',
    defaultMessage: 'Add Damage',
  },
  whatHappendValidationDescription: {
    id: 'app.whatHappened.validationDescription',
    defaultMessage: 'Description is required',
  },
  whatHappendVehicleCollision: {
    id: 'app.whatHappened.vehicleCollision',
    defaultMessage: 'Vehicle Collision',
  },
  whatHappendWindshieldDamage: {
    id: 'app.whatHappened.windshieldDamage',
    defaultMessage: 'Windshield Damage',
  },
  whatHappendHitAndRun: {
    id: 'app.whatHappened.hitAndRun',
    defaultMessage: 'Hit and Run',
  },
  whatHappendNaturalDisaster: {
    id: 'app.whatHappened.naturialDisaster',
    defaultMessage: 'Natural Disaster',
  },
  claimsFillOutTheForm: {
    id: 'app.claims.claimType.form',
    defaultMessage: 'Fill out the form',
  },
})
